module.exports = __webpack_public_path__ + "static/media/home_logo_ch.eec2c03d.png";